import { CertNode } from "./cert-node";

export class Certificate {
    private rawJson: any;

    constructor(
        private id: number,
        private name: string,
        private issuerId: number,
        private issuer: string,
        private certId: number,
        private icon: string,
        private createdAt: string,
        private updatedAt: string,
        private validUntil: string,
        private showInOrgCard: boolean,
        private treeData: CertNode[],
        private status: string,
        private revocationReason: string | null = null,
        rawJson?: any
    ) {
        this.rawJson = rawJson;
    }

    public getId(): number { return this.id; }
    public getName(): string { return this.name; }
    public getIssuerId(): number { return this.issuerId; }
    public getIssuer(): string { return this.issuer; }
    public getCertId(): number { return this.certId; }
    public getIcon(): string { return this.icon; }
    public getCreatedAt(): string { return this.createdAt; }
    public getUpdatedAt(): string { return this.updatedAt; }
    public getValidUntil(): string { return this.validUntil; }
    public getShowInOrgCard(): boolean { return this.showInOrgCard; }
    public getTreeData(): CertNode[] { return this.treeData; }
    public getRawJson(): any { return this.rawJson; }
    public getStatus(): string { return this.status; }
    public getRevocationReason(): string | null { return this.revocationReason; }

    public setId(id: number): void { this.id = id; }
    public setName(name: string): void { this.name = name; }
    public setIssuerId(issuerId: number): void { this.issuerId = issuerId; }
    public setIssuer(issuer: string): void { this.issuer = issuer; }
    public setCertId(certId: number): void { this.certId = certId; }
    public setIcon(icon: string): void { this.icon = icon; }
    public setCreatedAt(createdAt: string): void { this.createdAt = createdAt; }
    public setUpdatedAt(updatedAt: string): void { this.updatedAt = updatedAt; }
    public setValidUntil(validUntil: string): void { this.validUntil = validUntil; }
    public setShowInOrgCard(showInOrgCard: boolean): void { this.showInOrgCard = showInOrgCard; }
    public setTreeData(treeData: CertNode[]): void { this.treeData = treeData; }
    public setRawJson(rawJson: any): void { this.rawJson = rawJson; }
    public setStatus(status: string): void { this.status = status; }
    public setRevocationReason(reason: string | null): void { this.revocationReason = reason; }
    public isTreeFormat(): boolean {
        return Array.isArray(this.treeData) && this.treeData.length > 0 && typeof this.treeData[0].name === 'string';
    }

    public static fromHttp(http: any): Certificate {
        let tree: CertNode[] = [];
        let raw: any = null;
        try {
            raw = typeof http.treeData === 'string'? JSON.parse(http.treeData) : http.treeData;
            if (Array.isArray(raw)) tree = raw as CertNode[];
        } catch (e) {
            console.error("Failed to parse certificate treeData", e);
        }

        const mappedIcon = http.icon == null || http.icon === '' ? null
            : (http.icon.startsWith('http://') || http.icon.startsWith('https://') || http.icon.startsWith('/'))
                ? http.icon
                : `/proxy/api/v0/fileservice/file/${http.icon}`;
        return new Certificate(
            http.id,
            http.name,
            http.issuerId,
            http.issuer,
            http.certId,
            mappedIcon,
            http.createdAt,
            http.updatedAt,
            http.validUntil,
            http.showInOrgCard,
            tree,
            http.status,
            http.revocationReason,
            raw
        );
    }
}
